import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import BackButton from '../components/BackButton';
import ProductCard from '../components/ProductCard';
import { useLocation } from '../contexts/LocationContext';
import { Loader2, TrendingUp, Clock, Percent } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DiscoverPage() {
  const { location: userLocation } = useLocation();
  const [nearbyProducts, setNearbyProducts] = useState([]);
  const [discountedProducts, setDiscountedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, [userLocation]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (userLocation) {
        params.append('lat', userLocation.lat);
        params.append('lng', userLocation.lng);
      }
      params.append('disponibile', 'true');

      // Fetch nearby products
      const nearbyParams = new URLSearchParams(params);
      nearbyParams.append('limit', '8');
      const nearbyResponse = await axios.get(`${API}/products?${nearbyParams.toString()}`);
      setNearbyProducts(nearbyResponse.data);

      // Fetch discounted products
      const allProducts = await axios.get(`${API}/products?${params.toString()}&limit=50`);
      const discounted = allProducts.data.filter(p => p.sconto && p.sconto > 0);
      setDiscountedProducts(discounted.slice(0, 8));
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 pb-safe" data-testid="discover-page">
      <Header showSearch={true} />

      <main className="px-4 py-4 max-w-7xl mx-auto space-y-8">
        <BackButton fallback="/home" />
        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
          </div>
        ) : (
          <>
            {/* Nearby Section */}
            <section>
              <div className="flex items-center gap-2 mb-4">
                <Clock className="w-5 h-5 text-blue-600" />
                <h2 className="font-outfit font-semibold text-lg text-slate-800">
                  Vicino a te
                </h2>
              </div>
              {nearbyProducts.length > 0 ? (
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                  {nearbyProducts.map((product) => (
                    <ProductCard key={product.id} product={product} />
                  ))}
                </div>
              ) : (
                <p className="text-slate-500 text-sm py-4">
                  Imposta la tua posizione per vedere i prodotti vicini
                </p>
              )}
            </section>

            {/* Discounted Section */}
            {discountedProducts.length > 0 && (
              <section>
                <div className="flex items-center gap-2 mb-4">
                  <Percent className="w-5 h-5 text-orange-500" />
                  <h2 className="font-outfit font-semibold text-lg text-slate-800">
                    Offerte e sconti
                  </h2>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                  {discountedProducts.map((product) => (
                    <ProductCard key={product.id} product={product} />
                  ))}
                </div>
              </section>
            )}
          </>
        )}
      </main>

      <BottomNav />
    </div>
  );
}
